// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBG6O_PEOSYAxAya6LFZKIXofXRrou19XI",
  authDomain: "kode-essens-global.firebaseapp.com",
  projectId: "kode-essens-global",
  storageBucket: "kode-essens-global.appspot.com",
  messagingSenderId: "325797968551",
  appId: "1:325797968551:web:1e040bad0052bc549d3982",
  measurementId: "G-SNFJXGJPHK"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app); // ← i tilfelle du vil bruke det senere

export { db, auth };
